(() => {
  if (window.voltUIReady) return;
  window.voltUIReady = true;
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.('[data-volt-menu]') || !menu.open) return;
    document.querySelectorAll('[data-volt-menu][open]').forEach(other => {
      if (other !== menu) other.open = false;
    });
  }, true);
  function focusFormResult() {
    const result = document.querySelector('.vu-form [role="alert"], .vu-form [role="status"]');
    if (result) result.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusFormResult);
  else focusFormResult();
})();

(() => {
  const init = () => document.querySelectorAll('[data-volt-brands]').forEach(root => {
    if (root.dataset.ready || !root.querySelector('[data-brand-search]')) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-brand-search]');
    const cards = [...root.querySelectorAll('[data-brand-card]')];
    const buttons = [...root.querySelectorAll('[data-brand-letter]')];
    const empty = root.querySelector('[data-brand-empty]');
    const count = root.querySelector('[data-brand-count]');
    const fold = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ro');
    let letter = 'all';
    const filter = () => {
      let found = 0;
      const query = fold(search.value.trim());
      cards.forEach(card => {
        const name = card.dataset.brandName;
        const match = fold(name).includes(query) && (letter === 'all' || name[0].toUpperCase() === letter);
        card.hidden = !match;
        if (match) found++;
      });
      count.textContent = count.dataset.resultTemplate.replace('__COUNT__', found);
      empty.hidden = found > 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brandLetter === letter)));
    };
    search.addEventListener('input', filter);
    buttons.forEach(button => button.addEventListener('click', () => { letter = button.dataset.brandLetter; filter(); }));
    root.querySelector('[data-brand-reset]').addEventListener('click', () => { search.value = ''; letter = 'all'; filter(); search.focus(); });
    root.querySelector('[data-brand-tools]').hidden = false;
    filter();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
